var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.268 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 124,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.268 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6AABC",
    d: "m52.301 76.314 5.17.679L55.369 93l-5.17-.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8489A0",
    d: "m52.352 76 5.17.679-.352 2.676-5.17-.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.82 16.038c2.914-3.833 8.89-3.048 10.718 1.408L90.96 72.125c1.815 4.426-1.83 9.16-6.573 8.537L26.184 73.02c-4.743-.623-7.042-6.138-4.146-9.945L57.82 16.038Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.517 32.775a2.952 2.952 0 0 0-3.312 2.543L54.95 52.504a2.952 2.952 0 1 0 5.854.77l2.257-17.188a2.952 2.952 0 0 0-2.543-3.311Zm-3.498 26.64a2.952 2.952 0 0 0-3.312 2.543l-.177 1.346a2.952 2.952 0 1 0 5.855.77l.176-1.347a2.952 2.952 0 0 0-2.542-3.311Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27.747,
    y1: 13.214,
    x2: 80.134,
    y2: 96.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17D83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.72c459416c6c442fd925789a95e47904.svg";
export { ForwardRef as ReactComponent };